import { render } from "./App.vue?vue&type=template&id=e579e4a6"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e579e4a6&lang=css"

import exportComponent from "/Users/ashrock_m13/Ashrockzzz/git_amrita/virtuallab-oop/exp-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__